// extracted by mini-css-extract-plugin
export default {"tx":"_335095b105","line":"_11019d458a"};